import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  featuredJobs,
  show_proper_words,
  show_des_data,
} from "../../utils/Constant";
import { useMediaQuery } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import {
  delete_live_job_feed_api,
  favourite_live_job_api,
  job_reniew_api,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import { s3baseUri } from "../../config/config";
import JobFeedList from "../liveJobFeed/JobFeedList";
import { _get_job_feed_list_blog_api_without_filters } from "../../DAL/jobs/jobs";
import CustomPopoverNew from "../../components/CustomPopoverNew";
import SharePostPopup from "../../components/cards/SharePostPopup";
import CustomModalLayout from "../../components/modal/CustomModalLayout";

export default function MyJobPost() {
  const navigate = useNavigate();
  const {
    findId,
    setBreadCrumb,
    isRefresh,
    userInfo,
    handleReportPost,
    setUpdateJobOnNotification,
  } = useIds();
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const isTablet = useMediaQuery("(max-width:768px)");

  const [openDetail, setOpenDetail] = useState(false);
  const [cv, setCv] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const params = useParams();

  const [open, setOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [openRenewConfirm, setOpenRenewConfirm] = useState(false);
  const [renewJobId, setRenewJobId] = useState(null);

  const [editMode, setEditMode] = useState(false);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [partnersObj, setPartnersObj] = useState({});
  const scrollRef = useRef(null);
  const sourceSlug = params?.source_slug ? params?.source_slug : "";

  // share job State
  const [openSharePost, setOpenSharePost] = useState(null);
  const limit_per_page = 50;
  const load_more_path =
    "api/jobs/personal_list?page=0&limit=" + limit_per_page;

  const handleOpenDetail = (job) => {
    const slug = job.source.slug;

    const jobTypeSlug =
      userInfo.navbar
        ?.find((item) => item.source_slug == slug)
        ?.features.find((feature) => feature.type === "job")?.slug ||
      "live-job-feed";

    navigate(`/${slug}/${jobTypeSlug}/job/${job?.job_slug}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const fetchCategories = async (
    path,
    search,
    loading,
    id,
    pagination_type
  ) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }

    if (!path) {
      path = load_more_path;
    }
    const is_multi_page = pagination_type === "multi_page";
    if (is_multi_page) {
      setLoading(true);
    }

    const response = await _get_job_feed_list_blog_api_without_filters(
      sourceSlug,
      search,
      path
    );
    if (response.code === 200) {
      setLoadMorePath(response?.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);
      if (loading || is_multi_page) {
        let new_array = categories.concat(response?.jobs);
        if (is_multi_page) {
          setCategories(response.jobs);
        } else {
          setCategories(new_array);
          setPageNumber((prev) => prev + 1);
        }
      } else {
        setCategories(response?.jobs);
        setPageNumber(1);
      }
      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = (pagination_type, value) => {
    console.log(value, "pagination_type");
    setPageNumber(value);
    setIsLoadingMore(true);
    const custom_path = `api/jobs/personal_list?page=${
      value - 1
    }&limit=${limit_per_page}`;
    fetchCategories(custom_path, searchTerm, true, findId, pagination_type);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath]
  );
  // Initial load
  useEffect(() => {
    fetchCategories(load_more_path, searchTerm, false, findId);
  }, [isRefresh, findId, navigate]);

  // Search with debounce
  useEffect(() => {
    if (!loading && searchTerm !== "") {
      const timeoutId = setTimeout(() => {
        fetchCategories(load_more_path, searchTerm, false, findId);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm]);
  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);

  useEffect(() => {
    const jobTypeSlug =
      userInfo.navbar
        ?.find((item) => item.source_slug == firstSegment)
        ?.features.find((feature) => feature.type === "job")?.slug ||
      "live-job-feed";
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: `/${firstSegment}/${jobTypeSlug}/my-job-post`,
        active: false,
      },
      {
        name: `My Job Posts`,
        path: `/${firstSegment}/${jobTypeSlug}/my-job-post`,
        active: true,
      },
    ]);
  }, [navigate]);
  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
  };

  // Filter state
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    experience: "",
    jobType: "",
    frequency: "",
    salary: "",
    education_required: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    experience: null,
    jobType: null,
    frequency: null,
    salary: null,
    education_required: null,
  });

  // Filter handlers
  const handleFilterChange = (e) => {
    setFilterValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleFilterDrawerOpen = () => setFilterDrawerOpen(true);
  const handleFilterDrawerClose = () => setFilterDrawerOpen(false);
  const handleFilterClear = () => {
    setFilterValues({
      experience: "",
      jobType: "",
      frequency: "",
      salary: "",
      education_required: "",
    });
    setAppliedFilters({
      experience: null,
      jobType: null,
      frequency: null,
      salary: null,
      education_required: null,
    });
    setFilterDrawerOpen(false);
  };
  const handleRemoveFilterChip = (key) => {
    setFilterValues((prev) => ({ ...prev, [key]: "" }));
    setAppliedFilters((prev) => ({ ...prev, [key]: null }));
  };

  const handleNavigateAppliedJobs = () => {
    navigate(`/${firstSegment}/applied-jobs`);
  };
  const applyFilters = (e) => {
    if (e) e.preventDefault();

    setFilterDrawerOpen(false);

    setAppliedFilters({
      experience: filterValues.experience || null,
      jobType: filterValues.jobType || null,
      frequency: filterValues.frequency || null,
      salary: filterValues.salary || null,
      education_required: filterValues.education_required || null,
    });
  };

  // Filter categories client-side
  const filteredCategories = categories.filter((job) => {
    if (
      appliedFilters.experience &&
      job.experienceRequired !== appliedFilters.experience
    )
      return false;
    if (appliedFilters.jobType && job.jobType !== appliedFilters.jobType)
      return false;
    if (
      appliedFilters.frequency &&
      job.frequencySalary !== appliedFilters.frequency
    )
      return false;
    if (
      appliedFilters.salary &&
      String(job.salary) !== String(appliedFilters.salary)
    )
      return false;
    if (
      appliedFilters.education_required &&
      job.educationRequired !== appliedFilters.education_required
    )
      return false;

    return true;
  });

  const handleRenewJob = async (id) => {
    const response = await job_reniew_api(id);
    if (response?.code === 200) {
      enqueueSnackbar(response?.message, { variant: "success" });
      setCategories((prev) =>
        prev.map((obj) =>
          obj._id === id
            ? {
                ...obj,
                renewalStatus: {
                  ...obj.renewalStatus,
                  canRenew: false,
                },
              }
            : obj
        )
      );
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response?.message, { variant: "error" });
    }
    setOpenRenewConfirm(false);
  };
  const handleRenewClick = (id) => {
    setRenewJobId(id);
    setOpenRenewConfirm(true);
  };
  const MENU_OPTIONS = (job) => {
    if (job?.created_by?._id === userInfo?.profile_id) {
      let optionsArray = [];
      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        });
      }

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        });
      }

      optionsArray.push({
        label: "Share Job",
        icon: "mdi:share-outline",
        handleClick: (row) => {
          handleOpenSharePost(row);
        },
      });

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.delete &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
        });
      }

      return optionsArray;

      return [
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row),
        },
        {
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        },
      ];
    } else {
      return [
        {
          label: "Share Job",
          icon: "mdi:share-outline",
          handleClick: (row) => {
            handleOpenSharePost(row);
          },
        },
        {
          label: "Report Job",
          icon: "material-symbols:report-outline",
          handleClick: (row, index) => handleNavigateReportJob(row),
          color: "error",
        },
      ];
    }
  };

  const handleNavigateReportJob = (job) => {
    // navigate(`/home/report/job/${job._id}`, {
    //   state: {
    //     backURL: `/favourite-jobs`,
    //   },
    // });
    handleReportPost(job, "job", handleFilterJob);
  };

  const handleFilterJob = (id) => {
    setCategories((prev) => prev.filter((item) => item._id !== id));
  };

  const getRenewalStatus = (row) => {
    if (!row?.next_renewal_date) return false;

    const renewalDate = new Date(row.next_renewal_date);
    const now = new Date();

    return renewalDate <= now; // true if arrived/passed, false otherwise
  };
  // useEffect(() => {
  //   if (!loading) {
  //     const timeoutId = setTimeout(() => {
  //       fetchCategories(loadMorePath, searchText);
  //     }, 800);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [searchText]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTerm(searchInputValue);
    }, 1000);
    return () => clearTimeout(handler);
  }, [searchInputValue]);

  const handleCloseDetail = () => {
    setOpenDetail(false);
    setCv(null);
  };

  // const handleOpenDetail = (job) => {
  //   setSelectedJob(job);
  //   setOpenDetail(true);
  // };

  let arr = [12, 34, 67, 12, 88, 9, 0];
  let max = arr[0];
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      max = arr[i];
    }
  }

  const handleBookmarkToggle = (jobId) => {
    const newBookmarkedState = !bookmarkedJobs[jobId]; // Toggle state optimistically

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };
  const handleCandidates = (job) => {
    const slug = job.source.slug;

    const jobTypeSlug =
      userInfo.navbar
        ?.find((item) => item.source_slug == slug)
        ?.features.find((feature) => feature.type === "job")?.slug ||
      "live-job-feed";

    navigate(`/${slug}/${jobTypeSlug}/job-candidates-page/${job._id}`, {
      state: {
        job,
        pathname: `/${slug}/${jobTypeSlug}/my-job-post`, // Pass the source path for breadcrumb
      },
      topic: featuredJobs,
    });
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handlePersonalJob = (job) => {
    const jobTypeSlug =
      userInfo.navbar
        ?.find((item) => item.source_slug == firstSegment)
        ?.features.find((feature) => feature.type === "job")?.slug ||
      "live-job-feed";

    navigate(`/${firstSegment}/${jobTypeSlug}/personal-jobs`);
  };

  const handleClose = () => {
    setEditMode(false);
    setSelectedJob(null);

    setOpen(false);
  };
  const handleOpenEditJob = (job) => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    // setEditMode(true);
    // setSelectedJob(job);
    // setOpen(true);

    navigate(`/${job.source.slug}/edit-job/${job.job_slug}`, {
      state: { job },
    });
  };

  // share post state and functions
  const handleOpenSharePost = (job) => {
    setSelectedJob(job);
    setOpenSharePost(true);
  };

  const handleCompanyNameClick = (Job, e) => {
    e.preventDefault();
    e.stopPropagation();
    setCompanyModalData(Job?.created_by);
    setCompanyModalOpen(true);
  };

  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setDeleteLoading(true);
    console.log("Deleting Member ID:", id); // Debugging ke liye

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };
  const renderFilterChips = () => {};

  const handleDelete = (row) => {
    setDeletingMemberId(row.job_slug);
    setDeleteDialogOpen(true);
  };

  const handleUpdateSpecificJob = (updatedJob, setList = setCategories) => {
    console.log("updated data", updatedJob);
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setCategories);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [categories]);

  return (
    <>
      <JobFeedList
        isTablet={isTablet}
        categories={filteredCategories}
        loading={loading}
        appliedFilters={appliedFilters}
        renderFilterChips={renderFilterChips}
        handleFilterClear={handleFilterClear}
        scrollRef={scrollRef}
        lastBookElementRef={lastBookElementRef}
        loadMoreData={loadMoreData}
        isLoadingMore={isLoadingMore}
        totalPages={totalPages}
        pageNumber={pageNumber}
        handleOpenDetail={handleOpenDetail}
        handleCompanyNameClick={handleCompanyNameClick}
        s3baseUri={s3baseUri}
        userInfo={userInfo}
        bookmarkedJobs={bookmarkedJobs}
        handleBookmarkToggle={handleBookmarkToggle}
        MENU_OPTIONS={MENU_OPTIONS}
        handlePersonalJob={handlePersonalJob}
        handleOpen={handleOpen}
        handleNavigateAppliedJobs={handleNavigateAppliedJobs}
        filterDrawerOpen={filterDrawerOpen}
        handleFilterDrawerClose={handleFilterDrawerClose}
        fetchCategories={fetchCategories}
        filterValues={filterValues}
        applyFilters={applyFilters}
        handleFilterChange={handleFilterChange}
        handleRemoveFilterChip={handleRemoveFilterChip}
        companyModalOpen={companyModalOpen}
        handleCloseCompanyModal={handleCloseCompanyModal}
        companyModalData={companyModalData}
        openDetail={openDetail}
        cv={cv}
        selectedJob={selectedJob}
        setCv={setCv}
        handleCloseDetail={handleCloseDetail}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        sourceId={sourceId}
        openUpgradeModal={openUpgradeModal}
        setOpenUpgradeModal={setOpenUpgradeModal}
        openRenewConfirm={openRenewConfirm}
        setOpenRenewConfirm={setOpenRenewConfirm}
        handleRenewJob={handleRenewJob}
        renewJobId={renewJobId}
        load_more_path={load_more_path}
        findId={findId}
        searchTerm={searchTerm}
        searchInputValue={searchInputValue}
        handleInputChange={handleInputChange}
        handleFilterDrawerOpen={handleFilterDrawerOpen}
        show_des_data={show_des_data}
        handleCandidates={handleCandidates}
        setIsHovered={setIsHovered}
        deleteDialogOpen={deleteDialogOpen}
        handleDeleteMember={handleDeleteMember}
        setDeleteDialogOpen={setDeleteDialogOpen}
        deletingMemberId={deletingMemberId}
        pageTitle={"My Job Posts"}
        isMyJobPost={true}
        isFavourite={false}
        sourceSlugInside={sourceSlug}
      />

      {openSharePost && (
        <CustomModalLayout
          open={openSharePost}
          onClose={() => setOpenSharePost(false)}
          title="Share Job"
          width="550px"
          componentToPass={
            <SharePostPopup
              postData={{
                ...selectedJob,
                _id: selectedJob.job_slug,
                description: selectedJob.job_title,
              }}
              type={"job"}
            />
          }
        />
      )}
    </>
  );
}
